import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ButtonGroup, Container, Image, Nav, Navbar } from "react-bootstrap";
import NetworkDropdown from "./components/NetworkDropdown";
import ConnectWallet from "./components/ConnectWallet";

import "./Header.scss";
import MobileMenu from "./components/MobileMenu";
import { useRootContext } from "context/app-context";
import WalletAsidebar from "components/asidebar/WalletAsidebar";
import { isSwapRouteEnabled } from "utils/helper";

const Header = () => {
  const [scroll, setScroll] = useState(false);
  const [mobMenu, setMobMenu] = useState(false);

  const { isSignWallet } = useRootContext();

  const { pathname } = useLocation();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  return (
    <>
      <Navbar className={`fixed-top ${scroll ? "active" : ""}`}>
        <Container fluid>
          <Navbar.Brand href="/">
            <Image
              src={process.env.REACT_APP_S3_IMAGE_PATH + "logo.svg"}
              fluid
            />
          </Navbar.Brand>

          <Navbar.Collapse className="justify-content-end">
            <Nav className="m-auto deskOnly">
              <NavLink to={"/"} activeclassname="active" className="nav-link">
                Home
              </NavLink>
              {/* <a
                href={process.env.REACT_APP_STAKING_URL}
                without
                rel="noreferrer"
                className="nav-link"
              >
                Pre-stake
                <span className="nav-tag">Closed</span>
              </a> */}
              <NavLink
                to={"/swap"}
                onClick={(e) => {
                  !isSwapRouteEnabled && e.preventDefault();
                }}
                activeclassname="active"
                className={`nav-link ${!isSwapRouteEnabled ? "disabled" : ""}`}
              >
                Swap
              </NavLink>
            </Nav>

            <ButtonGroup className="ml-auto relative">
              {["/swap"].includes(pathname) && (
                <>
                  {isSignWallet && <NetworkDropdown />}

                  <ConnectWallet />
                </>
              )}
              <div className={`toggleMenu mobOnly ${["/swap"].includes(pathname) && 'swap-page'}`}>
                <button
                  className={`toggle-menu-btn ${mobMenu && "active"}`}
                  onClick={() => setMobMenu(!mobMenu)}
                  id="nav-icon"
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              </div>
            </ButtonGroup>
          </Navbar.Collapse>
        </Container>

        <MobileMenu
          mobMenu={mobMenu}
          handleClose={() => setMobMenu(!mobMenu)}
        />
      </Navbar>

      <WalletAsidebar />
    </>
  );
};

export default Header;
